import { useState } from 'react';
import { catchBackendApiClient } from '../../../../client/customFetcher';

export function useDownloadLabOrder() {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadOrder = async (orderId: string) => {
    if (!orderId) {
      console.error('No order ID provided for download');
      return;
    }

    setIsDownloading(true);
    try {
      const response = await catchBackendApiClient.get(
        `/v1/labs/orders/${orderId}/requisition`,
        { responseType: 'blob' }
      );

      // Create object URL and trigger download
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = `lab-order-requisition-${orderId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading order requisition:', error);
      alert('Failed to download order requisition. Please try again or contact support.');
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    downloadOrder,
    isDownloading,
  };
}
